import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'filenameFromFilepath', standalone: true})
export class FilenameFromFilepathPipe implements PipeTransform {

    transform(filepath: string): string {
        const splitedFilepath = filepath.split('/');
        const filename =splitedFilepath[(splitedFilepath.length)-1];
        return filename.split('?')[0];
    }
}